import React from "react";
import Header from "./components/header/Header";
import Nav from "./components/nav/Nav";
import About from "./components/about/About";
import Experience from "./components/experience/Experience";
import Services from "./components/services/Services";
import Contact from "./components/contact/Contact";
import Footer from "./components/footer/Footer";
import Testimonials from "./components/testimonials/Testimonials";
import Portfolio from "./components/portfolio/Portfolio";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Calculator from "./projects/calculator/Calculator";
import List from "./projects/todo-list/Todo";
import ImageSearch from "./projects/image-search/components/ImageSearch";
import YoutubeMain from "./projects/youtube-search/components/YoutubeMain";
import MathGame from "./projects/math-game/MathGame";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <Nav />
              <About />
              <Experience />
              <Services />
              <Portfolio />
              <Testimonials />
              <Contact />
              <Footer />
            </>
          }
        />
        <Route
          path="/projects/calculator"
          element={
            <>
              <Calculator />
              <Footer />
            </>
          }
        />
        <Route
          path="/projects/list"
          element={
            <>
              <List />
              <Footer footerStyle="list-footer" />
            </>
          }
        />
        <Route
          path="/projects/imagesearch"
          element={
            <>
              <ImageSearch />
              <Footer footerStyle="imagesearch-footer" />
            </>
          }
        />
        <Route
          path="/projects/youtube"
          element={
            <>
              <YoutubeMain />
              <Footer footerStyle="youtube__footer" />
            </>
          }
        />
        <Route
          path="/projects/mathgame"
          element={
            <>
              <MathGame />
              <Footer footerStyle="mathgame__footer" />
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
